<template>
  <div id="admin-app" class="min-h-screen" :class="{ dark: isDark }">
    <template v-if="authStore.isAuthenticated">
      <div class="flex h-screen overflow-hidden">
        <AppSidebar :collapsed="sidebarCollapsed" @toggle="sidebarCollapsed = !sidebarCollapsed" />
        <div class="flex-1 flex flex-col overflow-hidden">
          <AppHeader @toggle-sidebar="sidebarCollapsed = !sidebarCollapsed" />
          <main class="flex-1 overflow-auto bg-gray-50 dark:bg-gray-900 p-4">
            <router-view v-slot="{ Component }">
              <transition name="fade" mode="out-in">
                <component :is="Component" />
              </transition>
            </router-view>
          </main>
        </div>
      </div>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import AppSidebar from '@/components/layout/AppSidebar.vue'
import AppHeader from '@/components/layout/AppHeader.vue'

const authStore = useAuthStore()
const sidebarCollapsed = ref(false)

const isDark = computed(() => {
  return localStorage.getItem('admin-theme') === 'dark'
})
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
